import { gql } from '@apollo/client';

export const ProductFullDetailsModalFragment = gql`
  fragment ProductFullDetailsModalFragment on Variant {
    care
    imported
    materials {
      title
      percentage
      # type
    }
  }
`;

export default {};
